const zIndex = {
  drawer: 1200,
  layoutHeader: 1100,
  message: 1400,
  modal: 1300,
  tooltip: 1500,
};

export { zIndex };
